export default "__VITE_ASSET__sqgui2bM__"